import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { LOGO_URL } from '../data/brand';
export function FinalCta() {
  return <section className="w-full bg-ink py-28 sm:py-36 lg:py-48" aria-labelledby="final-title" data-id="element-78" data-mp="vhaj4by4od0a">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-79" data-mp="19cmdujcaa3h7">
        <Reveal data-id="element-80" data-mp="15bsp5nr0okn9">
          <img src={LOGO_URL} alt="EXPANDE — Tu visión. Tus posibilidades." className="h-12 w-auto opacity-70 sm:h-14" data-id="element-81" data-mp="15fgialsjv51g" />
        </Reveal>

        <Reveal delay={0.06} data-id="element-82" data-mp="1eds48aih1enk">
          <h2 id="final-title" className="mt-12 max-w-4xl font-serif text-[2.3rem] leading-[1.08] text-ivory sm:text-6xl xl:text-[4.2rem]" data-id="element-83" data-mp="1t2ycsp378h84">
            Tu visión puede llevarte
            <br className="hidden sm:block" data-id="element-84" data-mp="223cz9rrwg2d7" /> a nuevas posibilidades.
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-85" data-mp="1x4ta7ii0eagm">
          <p className="mt-10 max-w-xl font-sans text-base font-light leading-relaxed text-steel-200 sm:text-lg" data-id="element-86" data-mp="1x5upjz625j45">
            Todo crecimiento comienza con una decisión: estar abierto/a a
            conocer algo nuevo.
          </p>
        </Reveal>

        <Reveal delay={0.14} data-id="element-87" data-mp="x3s5ud5kay3k">
          <ul className="mt-12 max-w-md space-y-4 border-t border-ivory/15 pt-8 font-sans text-base font-light text-ivory/85 sm:text-lg" data-id="element-88" data-mp="x3ipzie8e7bl">
            <li data-id="element-89" data-mp="1246i67e74u7e">Conoce la oportunidad.</li>
            <li data-id="element-90" data-mp="164qg3d6lg1ul">Haz tus preguntas.</li>
            <li data-id="element-91" data-mp="163oy0or5uf3d">Decide si es para ti.</li>
          </ul>
        </Reveal>

        <Reveal delay={0.18} data-id="element-92" data-mp="1b2rw1p8q3l1u">
          <CtaButton label="Agendar una conversación" tone="champagne" className="mt-14" data-id="element-93" data-mp="1b1yynevnm7wd" />
        </Reveal>
      </div>
    </section>;
}